import React from 'react'
import ReactDom from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  withRouter,
  Switch
} from 'react-router-dom'
import { Provider, connect } from 'react-redux'
import { GearIcon, CrownIcon, HomeIcon, TripIcon, ReportIcon, CoinIcon, CarIcon, DoorIcon, RefundIcon, TripsIcon, MarkerIcon, DeliveryIcon, BankCardIcon, BriefcaseIcon, UserIcon, TrackerIcon } from '../../core/icons'
import './TeamsMenu.css'
import { logout } from '../../user/actions'
import { push } from 'react-router-redux';
import {Icon} from 'antd';

// https://reacttraining.com/react-router/web/example/custom-link
const IconLink = ({ label, to, activeOnlyWhenExact, icon: Icon, activeColor='#31B59F'}) =>
  <Route path={to} exact={activeOnlyWhenExact} children={({ match }) =>
     <div className={match ? 'active' : ''}>
      <Link to={to}>{match ? <Icon color={activeColor}/> : <Icon/>}<span>{label}</span></Link>
    </div>
  }/>

const TeamsMenu = ({ dispatch, forceDisplay }) => (
  <div className="TeamsMenu" style={forceDisplay ? {display: 'block'}: null}>
    <a onClick={()=>{ dispatch(push(`/dashboard`)) }}>
      <Icon style={{fontWeight: "600", color: "#31b59f"}} type="left" />
      <span style={{fontWeight: "600", color: "#31b59f"}}> BACK</span>
    </a>
    <hr/>
    <IconLink to={`/teams/members`} label="Members" icon={UserIcon}/>
    <IconLink to={`/teams/data-exports`} label="Data Exports" icon={ReportIcon}/>
    <hr/>
    <IconLink to={`/teams/premium`} label="Billing" icon={CrownIcon}/>
  </div>
)

export default connect()(TeamsMenu)



// WEBPACK FOOTER //
// ./src/enterprise/menu/TeamsMenu.js